import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../../_metronic/layout/core'
import DealerSchemeTable from './components/DealerSchemeTable'
import DealerSchemeForm from './components/DealerSchemeForm'

const crmBreadcrumb: PageLink = { title: 'CRM', path: '/', isSeparator: false, isActive: false }
const crmDealerSchemeBreadcrumb: PageLink = {
  title: 'Dealer Schemes',
  path: '/crm/dealer-schemes',
  isSeparator: false,
  isActive: true,
}

function DealerSchemePage() {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb]}>Dealer Schemes</PageTitle>
              <DealerSchemeTable />
            </>
          }
        />

        <Route
          path='/add'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmDealerSchemeBreadcrumb]}>
                Add Dealer Scheme
              </PageTitle>
              <DealerSchemeForm />
            </>
          }
        />

        <Route
          path='/edit/:id'
          element={
            <>
              <PageTitle breadcrumbs={[crmBreadcrumb, crmDealerSchemeBreadcrumb]}>
                Edit Dealer Scheme
              </PageTitle>
              <DealerSchemeForm />
            </>
          }
        />
      </Route>

      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export default DealerSchemePage

